var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.organization)?_c('div',[(_vm.$currentUserCan(_vm.$permissions.PERM_VIEW_ANY_ORGANIZATIONS))?_c('object-link',{attrs:{"object":_vm.organization}}):_c('span',[_vm._v(_vm._s(_vm.$objectDenomination(_vm.organization)))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }